import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip
} from '@mui/material';
import RoutineSchema from './RoutineSchema';

const RoutineViewer = ({ routine, open, onClose }) => {
  const handleClose = () => {
    onClose();
  };

  if (!routine) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">{routine.name}</Typography>
          <Chip 
            label={routine.class_name || 'Unknown Class'} 
            color="primary" 
            variant="outlined" 
            size="small"
          />
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <RoutineSchema routine={routine} />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RoutineViewer;
